import React, { useState } from "react";
import { Select, Checkbox } from "antd";
import { DownOutlined } from "@ant-design/icons";
import "../css/customSearchDropdown.css"
import "../css/label.css";
import "../css/customErrorForFields.css";
import "../css/customLabelDropDown.css";
import Label from "./Label";
import WarningIcon from "../../../../assets/warning.svg";
import searchIcon from "../../../../assets/Search-Icon.svg"
import LabelAndInputField from "./LabelAndInputField";

const { Option } = Select;

export default function CustomSearchDropdown({
    labelText,
    isCompulsary,
    controlId,
    controlName,
    value,
    options = [],
    maxTagCount =2,
    handleSelectChange,
    errorMessage,
    isDisabled,
    placeholder,
    isRequired,
    wrapperClass,
    multiSelect = false,
    showSearch=true,
    style,
    ...props
}) {
    const [searchText, setSearchText] = useState("");
    const hasError = Boolean(errorMessage);

    const filteredOptions = searchText ? options.filter((opt) =>
        opt.label.toLowerCase().includes(searchText.toLowerCase())
    ) : options;


    const getSanitizedValue = () => {
        if (hasError) return undefined;

        if (multiSelect) {
            if (!Array.isArray(value)) return [];
            return value.filter(v => v !== "" && v !== null && v !== undefined);
        }
        return value ?? undefined;
    };


    const onSelectionChange = (val) => {

        const syntheticEvent = {
            target: {
                id: controlId,
                name: controlName,
                value: val,
            },
        };
        if (handleSelectChange && typeof handleSelectChange === "function") {
            handleSelectChange(syntheticEvent);
        } else {
            console.warn(`No handler provided for ${controlId}`);
        }
    };

    return (

        <div style={style} className={`custom-field-wrapper ${wrapperClass || ""}`}>
            {/* Label Section */}
            {labelText && (
                <Label
                    className={"custom-label"}
                    labelText={labelText}
                    isCompulsary={isCompulsary}
                />
            )}
            <Select
                className={`custom-dropdown ${hasError ? "dropdown-error" : ""}`}
                id={controlId}
                name={controlName}
                onChange={onSelectionChange}
                disabled={isDisabled}  
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                open={isDisabled ? false : undefined}
                menuItemSelectedIcon={null}
                value={getSanitizedValue()}
                optionLabelProp="label"
                mode={multiSelect ? "multiple" : undefined}
                maxTagCount={multiSelect ? maxTagCount : undefined}
                maxTagPlaceholder={(omittedValues) => (
                    <span style={{ color: '#000' }}>
                        + {omittedValues.length} more
                    </span>
                )}
                placeholder={placeholder}
                size="large"
                allowClear={!multiSelect}
                filterOption={false}
                shouldClearSearchOnSelect={false}
                style={style}
                showSearch ={false}
                showArrow={true}
                dropdownRender={(menu) => (
                    <div className="dropdown-wrapper">
                        {showSearch && (
                        <div className="dropdown-search"
                            onKeyDown={(e) => e.stopPropagation()}
                        >
                            <LabelAndInputField
                                placeholder="Search..."
                                value={searchText}
                                handleInputChange={(e) => setSearchText(e.target.value)}
                                suffixIcon={<img src={searchIcon} alt="search" />}
                                autoFocus
                            />
                        </div>
                        )}
                        <div className="custom-options-dropdown">{menu}</div>
                    </div>
                )}
                suffixIcon={
                    hasError ? (
                        <img
                            src={WarningIcon}
                            alt="error"
                            className="select-error-icon"
                        />
                    ) : (
                        <DownOutlined style={{ fontSize: '12px', color: '#bfbfbf', pointerEvents: 'none' }} />
                    )
                }
                {...props}
            >
                {filteredOptions.map((option) => (
                    <Option key={option.value} value={option.value}label={option.label}>
                        {multiSelect ? (
                            <div className="search-checkbox-option">
                                <span> {option.label}</span>
                                <Checkbox
                                    className="inner-checkbox"
                                    checked={Array.isArray(value) && value.includes(option.value)}
                                >
                                </Checkbox>
                            </div>
                        ) : (
                            option.label
                        )}
                    </Option>
                ))}

            </Select>
        </div>

    );
};


